import { createRoutesWithSaveInProgress } from 'platform/forms/save-in-progress/helpers';
import SurvivorsBenefitsApp from './containers/SurvivorsBenefitsApp';
import { loadCorrectFormConfig } from './reducers/helper';

export const createFormRoutes = store => {
  let childRoutes;
  let cachedVersion;
  return {
    path: '/',
    component: SurvivorsBenefitsApp,
    indexRoute: { onEnter: (nextState, replace) => replace('/introduction') },
    getChildRoutes(nextState, callback) {
      const { form } = store.getState();
      const pdfVersion = form?.data?.pdfVersion?.includes('2026')
        ? 'OCT-2026'
        : 'AUG-2025';
      if (!childRoutes || cachedVersion !== pdfVersion) {
        childRoutes = createRoutesWithSaveInProgress(
          loadCorrectFormConfig(pdfVersion),
          (cachedVersion = pdfVersion),
        );
      }
      callback(null, childRoutes);
    },
  };
};

export default createFormRoutes;
